import { VehicleType } from "@/libs/api/types";
import { Capacitor } from "@capacitor/core";

export function openNavigationApp(address: string, vehicle: VehicleType) {
  if (Capacitor.getPlatform() === "ios") {
    return openAppleMaps(address, vehicle);
  } else {
    return openGoogleMaps(address, vehicle);
  }
}

export function openGoogleMaps(address: string, vehicle: VehicleType) {
  const drivingMode = vehicle === VehicleType.CAR ? "driving" : "bicycling";

  const url = new URL("https://www.google.com/maps/dir/");
  url.searchParams.append("api", "1");
  url.searchParams.append("travelmode", drivingMode);
  url.searchParams.append("dir_action", "navigate");
  url.searchParams.append("destination", address);

  window.open(url.toString(), "_blank");
}

export function openAppleMaps(address: string, vehicle: VehicleType) {
  const url = new URL("http://maps.apple.com/");
  url.searchParams.append("q", address);
  url.searchParams.append("dirflg", mapIosTransportType(vehicle));

  window.open(url.toString(), "_blank");
}

function mapIosTransportType(vehicle: VehicleType) {
  switch (vehicle) {
    case VehicleType.BIKE:
      return "b";
    case VehicleType.CAR:
    default:
      return "d";
  }
}
